<template>	   
	<div>
    <v-layout row wrap>
      <v-flex xs6 pa-1> 
        <label for="">Variables</label>
        <v-autocomplete solo
          :items="variables"
          item-value="id"
          item-text="name"
          v-model="filters.id_variable"
          label="Variables"
        >
          <template v-slot:item="data">
            <v-list-item-action @click="data.item.active = !data.item.active">
              <v-icon>fas fa-subscript</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
              <v-list-item-sub-title>Tipo: {{ data.item.category }} | Nivel: {{ data.item.level }}  </v-list-item-sub-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs6 pa-1> 
        <label for="">Fecha</label>
        <v-text-field
          name="name" v-model="filters.date"
          label="Fecha" solo
          id="id" type="date"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-btn color="success"  @click="getMapData()"><v-icon>fas fa-search</v-icon></v-btn>
      </v-flex>
    </v-layout>
		<v-container v-if="!loadingPage && !noDataError">
			<v-card :min-height="500">
          <v-system-bar window dark >
            <v-btn text small fab @click="activateConfigDialog()">
              <v-icon>fas fa-cog</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text small fab @click="maxiMap()">
              <v-icon>far fa-square</v-icon>
            </v-btn>
            <v-btn text small fab @click="windowMapAction()">
              <v-icon :style="'transform: rotate(' + rotate + 'deg)'">fas fa-times</v-icon>
            </v-btn>
          </v-system-bar>
          <v-card-actions>
             <v-layout row wrap>
              <v-flex xs5 pa-1>
                <v-text-field
                  name="minOpacity"
                  label="Opacidad minima"
                  v-model="minOpacity"
                  id="id" type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs5 pa-1>
                <v-text-field
                  name="maxZoomHeat"
                  label="Zoom maximo" type="number"
                  id="id" v-model="maxZoomHeat"
                 ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-switch label="Tipo de mapa" v-model="heatActive"></v-switch>
              </v-flex>
              <v-flex xs6 pa-1 v-if="settings.rangeGradient">
                <v-subheader class="pl-0">Rango de gradiente</v-subheader>
                  <v-slider
                    v-model="radius" 
                    :min="0"
                    :max="70"
                    thumb-label="always"
                    ticks
                  ></v-slider>
              </v-flex>
              <v-flex xs6 pa-1 v-if="settings.rangeOpacity">
                <v-subheader class="pl-0">Rango de opacidad</v-subheader>
                <v-slider
                  v-model="blur"
                  :min="0"
                  :max="70"
                  thumb-label="always"
                  ticks
                ></v-slider>
              </v-flex>
            </v-layout>
          </v-card-actions>
         <v-card-text>    
          <l-map 
    				v-if="mapActive && !loadingMap" 
    			  id="map"
    				style="height: 500px;  margin-right: 5px " 
    				:zoom.sync="zoom" 
    				:options="mapOptions"  
    				:center="center"  
    				:min-zoom="minZoom" 
    				:max-zoom="maxZoom" >
    			 	<l-control-sum position="topleft"></l-control-sum>
              <l-control-layers 
              :position="layersPosition"/>
              <l-tile-layer 
              	v-for="(tileProvider, index) in tileProviders" 
              	:key="index"
                layerType="base" 
              	:name="tileProvider.name" 
              	:visible="tileProvider.visible" 
              	:url="tileProvider.url" 
              	:attribution="tileProvider.attribution" 
              	:token="token" 
              	:id="tileProvider"/>
    					<l-heat-point  
                v-if="heatActive"
                :lat-lng="heatPoints" 
                :radius="radius" 
                :min-opacity="minOpacity" 
                :max-zoom="maxZoomHeat" 
                :blur="blur">
              </l-heat-point> 
              <l-marker-cluster 
                v-if="!heatActive"
                :options="clusterOptions">
                <l-marker  
                  v-for="marker in points" 
                  :key="marker.id" 
                  :visible="true" 
                  :draggable="false" 
                  :lat-lng="[marker.lat, marker.lng]" 
                  >
                      <l-popup :content="marker.modal" />
                      <l-tooltip :content="marker.tooltip" />
                </l-marker>
              </l-marker-cluster>
            </l-map>
            <v-layout row justify-center v-if="loadingMap">
              <v-progress-circular indeterminate></v-progress-circular>
            </v-layout>
         </v-card-text>
        
      </v-card>
      <v-card>
        <v-card-text>
          <v-card-title primary-title>
            Datos
          </v-card-title>
          <v-card-text>
            <v-text-field
              name="search"
              label="Buscar..."
              id="id" append-icon="fas fa-search"
              v-model="searchDatatable"
            ></v-text-field>
            <v-data-table
              :headers="headers"
              :items="points"
              class="elevation-1"
              pagination.sync="pagination"
              item-key="id"
              :loading="loadingMap"
              :search="searchDatatable"
            >
              <template v-slot:items="props">
                <td>{{ props.item.tooltip }}</td>
                <td>{{ props.item.value }}</td>
                <td>{{ props.item.type }}</td>
                <td>
                  <v-btn color="blue-grey" @click="toMap(props.item)" icon><v-icon>fas fa-globe-americas</v-icon></v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card-text>
      </v-card>
		</v-container>
		<v-container v-if="loadingPage && !noDataError">
		  	<v-layout row wrap>
		  	 	<v-flex xs4 offset-xs4 class="text-md-center">
		  	 	  <v-progress-circular
				      :size="70"
				      :width="7"
				      color="blue"
				      indeterminate
			    ></v-progress-circular> 
	  	 	</v-flex> 
	  	</v-layout>
		</v-container>
		<v-container v-if="noDataError">
		 	<v-layout row wrap>
		 		<v-flex xs12 class="text-md-center">
		 			<h3 class="headline" color="error">Datos no encontrados</h3>
		 		</v-flex>	  
		 	</v-layout>	
		</v-container>
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      >
     <v-card :min-height="500">
          <v-system-bar window dark>
            <v-spacer></v-spacer>
            <v-btn text small fab @click="closeMaxiMap()">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-system-bar>      
        <l-map 
          v-if="heatMaxActive" 
          ref="map"  
          style="height: 100%; margin-right: 5px " 
          :zoom.sync="zoom" 
          :options="mapOptions"  
          :center="center"  
          :min-zoom="minZoom" 
          :max-zoom="maxZoom" >
          <l-control-sum position="topleft"></l-control-sum>
            <l-control-layers 
            :position="layersPosition"/>
            <l-tile-layer 
              v-for="(tileProvider, index) in tileProviders" 
              :key="index"
              layerType="base" 
              :name="tileProvider.name" 
              :visible="tileProvider.visible" 
              :url="tileProvider.url" 
              :attribution="tileProvider.attribution" 
              :token="token" 
              :id="tileProvider"/>
            <l-heat-point  
                v-if="heatActive"
                :lat-lng="heatPoints" 
                :radius="radius" 
                :min-opacity="minOpacity" 
                :max-zoom="maxZoomHeat" 
                :blur="blur">
            </l-heat-point> 
            <l-marker-cluster 
              v-if="!heatActive"
              :options="clusterOptions">
              <l-marker  
                v-for="marker in points" 
                :key="marker.id" 
                :visible="true" 
                :draggable="false" 
                :lat-lng="[marker.lat, marker.lng]" 
                @click="alert(marker)" 
                >
                  <l-popup :content="marker.modal" />
                  <l-tooltip :content="marker.tooltip" />
              </l-marker> 
            </l-marker-cluster>
          </l-map>
      </v-card>
    </v-dialog>
     <v-dialog
        v-model="configDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="configDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title color="white">Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="configDialog = false">Guardar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-list>
            <v-list-item avatar>
              <v-list-item-title>Visualizar rangos de gradiente</v-list-item-title>         
              <v-list-item-action>
                <v-switch v-model="settings.rangeGradient"></v-switch>
              </v-list-item-action>
            </v-list-item>        
            <v-list-item avatar>
              <v-list-item-title>Visualizar rangos de opacidad</v-list-item-title>         
              <v-list-item-action>
                <v-switch v-model="settings.rangeOpacity"></v-switch>
              </v-list-item-action>
            </v-list-item>        
            <v-list-item avatar>
              <v-list-item-content>
                <v-list-item-title>Calcular rangos de color por: </v-list-item-title>         
                <v-list-item-sub-title v-if="filters.rangeColors">Fecha</v-list-item-sub-title>
                <v-list-item-sub-title v-if="!filters.rangeColors">Punto</v-list-item-sub-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-switch @change="getMapData()" v-model="filters.rangeColors"></v-switch>
              </v-list-item-action>
            </v-list-item>           
          </v-list>
          <v-layout row wrap>
            <v-flex xs12>
              <v-subheader class="pl-0">Rango de gradiente</v-subheader>
                <v-slider
                  v-model="radius" 
                  :min="0"
                  :max="70"
                  thumb-label="always"
                  ticks
                ></v-slider>
            </v-flex>
            <v-flex xs12>
              <v-subheader class="pl-0">Rango de opacidad</v-subheader>
              <v-slider
                v-model="blur"
                :min="0"
                :max="70"
                thumb-label="always"
                ticks
              ></v-slider>
            </v-flex>
          </v-layout>
          <v-card>
            <v-card-title primary-title>
              Estadisticas de busqueda actual:
            </v-card-title>        
            <v-card-text>
              <v-layout row wrap v-if="stadistics.length > 0">
                <v-flex xs4 v-for="itemStadistic in stadistics">
                  {{ itemStadistic.label }}
                  <v-spacer></v-spacer>
                  {{ itemStadistic.value }}
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout v-if="stadistics.length == 0" row wrap justify-center>
                <v-flex xs10 offset-xs1 class="text-md-center">
                  No hay datos estadisticos disponibles
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>      
        </v-card-text>
      </v-card>
    </v-dialog>
	</div>
</template>
<script>
  import { latLng, Icon, icon } from 'leaflet'
	export default{
		created() {
			
		},
		mounted(){
		  this.getVariables();
    },
		props: [
			
		],
		data(){
			return {
        headers: [
          { text: 'Nombre', value: 'tooltip'},
          { text: 'Valor', value: 'value' },
          { text: 'Tipo', value: 'type' },
          { text: 'Acciones', value: 'actions' },
        ],
        searchDatatable: '',
        loadingMap: false,
        heatActive: true,
        dialog: false,
        maxZoomHeat: 10,
				minOpacity: 0.75,
        configDialog: false,
        baseRoute: process.env.VUE_APP_URL + 'api/gis',
        filters: {
          id_variable: '',
          date: '',
          rangeColors: false,
        },
        variables: [],
				loadingPage: false,
				points: [], //Apidefinition
				center: [-22.486628,-63.773381], //Apidefinition
				init: 0,
				mapActive: true,
        heatMaxActive: false,
				radius: 0,
				blur: 0,
        token: 'pk.eyJ1IjoiZmVybmFuZG9ncnVwb2luc3VkIiwiYSI6ImNqanR6anVoMDA5b2Mza21iNmcxMTgxbXgifQ.vQ25t76paHyoxymIj_WW7g',
        zoom:4,
				tileProviders: [
					{
						name: 'Carreteras',
						visible: true,
						id:'',
						key: 1,
						url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution: 'Mundo sano',
					},
					{
						name: 'Satelite 1',
						visible: false,
						id:'',
						key: 2,
						url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
          	attribution: 'Mundo sano - Centro para la prevencion de chagas',
					},
					{
						name: 'Satelite 2',
				    id: 'mapbox.satellite',
						visible: false,
            key: 3,
            accessToken: 'pk.eyJ1IjoiZmVybmFuZG9ncnVwb2luc3VkIiwiYSI6ImNqanR6anVoMDA5b2Mza21iNmcxMTgxbXgifQ.vQ25t76paHyoxymIj_WW7g',
            url: 'https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZmVybmFuZG9ncnVwb2luc3VkIiwiYSI6ImNqanR6anVoMDA5b2Mza21iNmcxMTgxbXgifQ.vQ25t76paHyoxymIj_WW7g',
            attribution: 'Mundo sano - Centro para la prevencion de chagas',
					},
				],
        clusterOptions: {
          
        },
        zoomPosition: 'topleft',
				mapOptions: { zoomControl: false , attributionControl: false },
				attributionPosition: 'bottomright',
        layersPosition: 'topright',
        attributionPrefix: 'Vue2Leaflet',    
        maxZoom:15,
        minZoom: 3,
       	heatPoints: [],
       	markers: [],
       	dataCollectionBar: '',
				dataCollectionPie: '',
				noDataError: false,
        rotate: 270,
        stadistics: [],
        settings: {
          rangeGradient: true,
          rangeOpacity: true,
          rangeColors: false,
          seeSubpro: false
        }
			}
		},
		methods: {
      getVariables(){
        axios.get(this.baseRoute + '/variables/getSelect').then((res) => {
          this.variables = res.data;
        }).catch((error) => {
          this.alert = {
            messague: 'Hay un error interno en el servidor pruebe nuevamente mas tarde',
            color: 'error',
            active: true,
            icon: 'fas fa-bell',            
          }
        });
      },
      getMapData(){
        this.mapActive = false;
        this.loadingMap = true;
        axios.put(this.baseRoute + '/results/getMapData', this.filters).then((res) => {
          this.loadingMap = false;
          this.heatPoints = res.data.heatMap;
          this.center  = [this.heatPoints[0][0], this.heatPoints[0][1]];
          this.mapActive = true;
          this.points = res.data.mapData
          this.stadistics = res.data.stadistic
          this.activeMarkers();
        }).catch((error) => {
          this.loadingMap = false;
        });
      },
		  activateConfigDialog(){
        this.configDialog = true;
        this.mapActive = false;
      },
      desactiveConfigDialog(){
        this.configDialog = false;
        this.mapActive = true;
      },
      windowMapAction(){
        this.mapActive = !this.mapActive;
        if(this.mapActive){
          this.rotate = 360; 
        }else{
          this.rotate = 135
        }
      },
      maxiMap(){
        this.dialog = true;
        this.mapActive = false;
        this.heatMaxActive = true;
      },
      closeMaxiMap(){
        this.dialog = false;
        this.mapActive = true;
        this.heatMaxActive = false;
      },
      setCenter(item){
        this.center = [item.lat, item.lng];
      },
      toMap(item){
        var options = {
          duration: 500,
          offset: 11,
          easing: 'easeInOutCubic'
        }
        setTimeout(this.setCenter(item), 4000);
        this.zoom = 11;
        this.$vuetify.goTo('#map', options)
      },  
      showData(item){

      }
		},
		watch: {
			
		},
		computed: {
		},
	}
</script>
<style>
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
  .v-toolbar:not(.v-toolbar--fixed) .v-toolbar__content {
    margin-left: 0px !important;
  }

</style>